module.exports = __webpack_public_path__ + "img/face-zipper.c20bb9ba.svg";